import type { JSX } from 'react';
import { cn } from '../../../lib/cn.js';
import { resolveAssetUrl } from './image-source.js';

export interface VideoProps {
  src: string;
  poster?: string;
  caption?: string;
  className?: string;
}

export function Video({ src, poster, caption, className }: VideoProps): JSX.Element {
  return (
    <figure className={cn('my-5', className)}>
      <video
        src={resolveAssetUrl(src)}
        poster={poster ? resolveAssetUrl(poster) : undefined}
        controls
        loop
        muted
        playsInline
        preload="metadata"
        className="block w-full rounded-lg border border-white/[0.06]"
      />
      {caption ? (
        <figcaption className="mt-2.5 text-center text-[13px] leading-[1.5] text-muted">
          {caption}
        </figcaption>
      ) : null}
    </figure>
  );
}
